import {configureStore} from '@reduxjs/toolkit'
import {lecturersReducer} from "../Reducers/LecturersReducer";

export const store = configureStore({
    reducer: {
        lecturers: lecturersReducer,
    },
})
